export const translations = {
  exchangable: "Nombre de la promoción",
  specification: "Resumen de la promoción",
  restrictionsAndDetails: "Detalles y restricciones de la promoción",
  category: "Categoria",
  categories: "",
  dueDate: "Válido hasta",
  status: "Estado",
};
